<template lang="pug">
  v-card.card-rc.elevation-3
    v-row.row-style
      p.text-style.text-mb-5 Имя *
    v-text-field.text-fild-rc.d-flex.justify-center(
      v-model="fio"
      placeholder="Иванов Иван Иванович"
      hide-details
      outlined
      )
    v-row.error-row-style
      p.error-style(v-show="fioError") {{fioError}}
    v-row.row-style
      p.text-style.text-mb-5 Телефон / E-mail *
    v-text-field.text-fild-rc.d-flex.justify-center(
      v-model="contact"
      placeholder="+7(900) 123 45 67 / example@mail.ru"
      hide-details
      outlined
      )
    v-row.error-row-style
      p.error-style(v-show="contactError") {{contactError}}
    v-row.row-style
      p.text-style.text-mb-4 Тип специалистов
    v-chip-group.lend-chip(v-model="specialistTeams" column multiple)
      v-chip.size-chip(
        v-for="teamTag in teamTags"
        :key="teamTag.id"
        :class="{'white-text': specialistTeams.includes(teamTag.name.toLowerCase()), 'base-style': !specialistTeams.includes(teamTag.name.toLowerCase())}"
        :value="teamTag.name.toLowerCase()"
        label
        large
      ) {{teamTag.name}}
    v-row.row-style
      p.text-style.text-mb-4.mt-2 Стек разработки
    v-chip-group.lend-chip(v-model="stackTechnologys" column multiple)
      v-chip.size-chip(
        v-for="stackTag in stackTags"
        :key="stackTag.id"
        :class="{'white-text': stackTechnologys.includes(stackTag.name), 'base-style': !stackTechnologys.includes(stackTag.name)}"
        :value="stackTag.name"
        label
        large
      ) {{stackTag.name}}
    v-row.row-style
      p.text-style.text-mb-4.mt-2 Количество сотрудников
    v-chip-group.lend-chip
      v-chip.size-chip.size-chip-employe(
        v-for="countDeveloper in employees"
        :key="countDeveloper.id"
        @click="selectCountDeveloper(countDeveloper.id)"
        :class="{'white-text': countDeveloper.isSelected, 'base-style': !countDeveloper.isSelected}"
        :disabled="countDeveloper.isDisabled"
        label
      ) {{countDeveloper.num}}
    v-row.row-style
      p.text-style.text-mb-5.mt-2 Немного о проекте
    v-textarea.textarea-rc.d-flex.justify-center.hide-scrollbar(
      v-model="descriptionRequest"
      outlined
      hide-details
      no-resize
      )
    v-row.error-row-style
      p.error-style(v-show="descriptionRequestError") {{descriptionRequestError}}
    .imput-rc
      v-file-input(v-show='false' v-model="files" id="files" multiple hide-input @click.stop="clearFile")
      label(for="files")
        a
          v-img.input-icon(src="@/assets/paperclip.svg")
      label.text-input-rc(for="files")
        a Прикрепить бриф или ТЗ (pdf, doc)
    .files-row-style(:class="{'chip-space': allFiles.length>=MAX_COUNT_FILES}")
      template(v-for="(file, i) in allFiles")
        tagChip(v-if="!!file.name" :isLastChip="(i+1)>=MAX_COUNT_FILES" @onClear="deleteFile(file)")
          template(v-slot:tooltip) {{ file.name.length>70 ? cutText(file.name, true) :  file.name}}
          | {{ cutText(file.name) }}
    v-row.error-row-style
      p.error-style(v-show="filesError") {{filesError}}
    v-card-actions.card-actions-style.justify-center.d-flex
      v-btn.text-none.btn-style(@click="createRequest" :disabled="!isAllFilled")
        | Оставить заявку
    .justify-center.d-flex
      p.text-footer Нажимая кнопку «Оставить заявку»,
    .text-footer-md.justify-center.d-flex
      p.text-footer я даю&nbsp;
        a(@click="openLink") согласие на обработку персональных данных
    .justify-center.d-flex
      p.text-footer *поля обязательные для заполнения
    v-dialog(v-model='dialog' width="500" @click:outside="dialog = false")
      v-card
        v-card-title.text-dialog Сообщение
          v-spacer
          a
            font-awesome-icon(@click="dialog=false" :icon="['fas', 'times']")
        v-divider
        v-card-text
          .text-dialog.mt-5
            | {{message}}
        v-divider
        v-card-actions
          v-spacer
          v-btn.text-capitalize.white-text.btn-color.text-dialog(@click="dialog=false")
            | Ок
</template>

<script>
  import tagChip from "@/components/ui/TagChip"
  import axios from "axios"
  import {MAX_COUNT_FILES, MAX_SIZE_FILES} from "@/main";

  export default {
    name: "RegistrationCard",
    components: {tagChip},
    props: {
      booking: {
        type: String,
        default: () => null
      }
    },
    data () {
      return {
        MAX_COUNT_FILES,
        MAX_SIZE_FILES,
        maxSizeFileMB: Number(MAX_SIZE_FILES) * 1024 * 1024,
        fio: '',
        contact: '',
        descriptionRequest: '',
        fioError: null,
        contactError: null,
        descriptionRequestError: null,
        filesError: null,
        countEmployees: null,
        isCanAddApplication: null,
        files: [],
        allFiles: [],
        dialog: false,
        message: '',
        teamTags: [
          {
            id: 1,
            name: 'Dev',
            isSelected: false
          },
          {
            id: 2,
            name: 'QA',
            isSelected: false
          },
          {
            id: 3,
            name: 'Analyst',
            isSelected: false
          },
          {
            id: 4,
            name: 'Project manager',
            isSelected: false
          },
          {
            id: 5,
            name: 'DevOps',
            isSelected: false
          }
        ],
        stackTags: [
          {
            id: 1,
            name: 'C#',
            isSelected: false
          },
          {
            id: 2,
            name: 'Ang',
            isSelected: false
          },
          {
            id: 3,
            name: 'TS',
            isSelected: false
          },
          {
            id: 4,
            name: 'Python',
            isSelected: false
          },
          {
            id: 5,
            name: 'Vue',
            isSelected: false
          },
          {
            id: 6,
            name: 'PHP',
            isSelected: false
          }
        ],
        employees: [
          {
            id: 1,
            num: '1',
            isDisabled: false,
            isSelected: false
          },
          {
            id: 2,
            num: '2',
            isDisabled: false,
            isSelected: false
          },
          {
            id: 3,
            num: '3',
            isDisabled: false,
            isSelected: false
          },
          {
            id: 4,
            num: '3<',
            isDisabled: false,
            isSelected: false
          }
        ],
        specialistTeams: [],
        stackTechnologys: [],
      }
    },
    watch: {
      booking: {
        immediate: true,
        deep: true,
        handler () {
          const team = ['FRONTEND', 'BACKEND'].includes(this.booking) ? 'Dev' : this.booking
          if (team && !this.specialistTeams.includes(team.toLowerCase())) {
              this.specialistTeams.push(team.toLowerCase())
          }
        }
      },
      fio: {
        immediate: true,
        deep: true,
        handler () {
          if (this.fio.length > 100) {
            this.fioError = '* Длинна поля не должна превышать 100 символов'
          } else {
            this.fioError = null
          }
        }
      },
      contact: {
        immediate: true,
        deep: true,
        handler () {
          if (this.contact.length > 50) {
            this.contactError = '* Длинна поля не должна превышать 50 символов'
          } else {
            this.contactError = null
          }
        }
      },
      descriptionRequest: {
        immediate: true,
        deep: true,
        handler () {
           if (this.descriptionRequest.length > 3000) {
            this.descriptionRequestError = '* Длинна поля не должна превышать 3000 символов'
          } else {
             this.descriptionRequestError = null
           }
        }
      },
      files: {
        immediate: true,
        deep: true,
        handler () {
          let countFileSizeError = 0
          let countFileExtensionError = 0
          this.filesError = null
          this.files.forEach((el) => {
            if (this.allFiles.length < Number(this.MAX_COUNT_FILES)) {
              if (['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf', 'txt'].includes(el.name.split(".").splice(-1,1)[0])) {
                  if (el.size > this.maxSizeFileMB) {
                      countFileSizeError = countFileSizeError + 1
                      this.filesError = `* Размер файла не должен превышать ${this.MAX_SIZE_FILES} Мб`
                  } else {
                      this.allFiles.push(el)
                  }
              } else {
                countFileExtensionError = countFileExtensionError + 1
                this.filesError = '* Недопустимый формат загружаемого файла'
              }
            } else {
              countFileSizeError = countFileExtensionError = 0
              this.filesError = '* Превышен допустимый лимит количества загружаемых файлов'
            }
          })
          if (countFileSizeError > 0 && countFileExtensionError > 0) {
              if (countFileExtensionError >= countFileSizeError) {
                this.filesError = '* Недопустимый формат загружаемого файла'
              } else {
                this.filesError = `* Размер файла не должен превышать ${this.MAX_SIZE_FILES} Мб`
              }
          }
          if (this.filesError) {
            setTimeout(() => this.filesError = null, 4000)
          }
        }
      },
      specialistTeams: {
        immediate: true,
        deep: true,
        handler () {
          const lenSpecialistTeams = this.specialistTeams.length
          if (lenSpecialistTeams < this.teamTags.length) {
            this.selectCountDeveloper(lenSpecialistTeams, true)
          }
        }
      }
    },
    created() {
      axios
        .post('/api/is_can_add_applicatication/')
        .then(response => {
          const {data} = response
          this.isCanAddApplication = data
        })
        .catch(error => {
          console.log( 'error')
        })
    },
    computed: {
      isAllFilled () {
        const isFio = this.fio && !this.fioError
        const isContact = this.contact && !this.contactError
        return (isFio && isContact && !this.descriptionRequestError && !this.filesError)
      }
    },
    methods: {
      openLink () {
        window.open(window.location.origin + '/Правила_защиты_информации.pdf')
      },
      async createRequest () {
        const fd = new FormData()
        for (const file of this.allFiles) {
           fd.append('filesList', file)
        }
        fd.append('fio', this.fio)
        fd.append('contact', this.contact)
        for (const stackTechnology of this.stackTechnologys) {
           fd.append('stackTechnologys', stackTechnology)
        }
        for (const specialistTeam of this.specialistTeams) {
           fd.append('specialistTeams', specialistTeam)
        }
        fd.append('countEmployees', this.countEmployees ? this.countEmployees : '')
        fd.append('descriptionRequest', this.descriptionRequest)
        axios
          .post('/api/is_can_add_applicatication/')
          .then(response => {
            const {data} = response
            if (data){
              this.message = 'Заявка успешно оформлена.'
              this.dialog = true
              axios
                .post('/api/specialist-teams/', fd, { headers: { 'Content-Type': 'multipart/form-data' } })
                .then()
                .catch(error => {
                  console.log( 'error')
                })
            } else {
              this.message = "Превышен допустимый лимит запросов"
              this.dialog = true
            }
          })
        .catch(error => {
          console.log( 'error')
        })
      },
      clearFile(){
        this.files=[]
      },
      selectCountDeveloper (id) {
        this.countEmployees = id
        this.employees.forEach((el) => {
          if (this.specialistTeams.length === 0) {
            el.id === this.countEmployees && !el.isSelected ? el.isSelected=true :  el.isSelected=false;
          } else {
            el.id === id ? el.isSelected=true :  el.isSelected=false;
          }
          (el.id < this.specialistTeams.length && el.id !== this.employees.length) ? el.isDisabled=true :  el.isDisabled=false
        })
      },
      deleteFile (file) {
        this.files = []
        this.allFiles.splice(this.allFiles.indexOf(file), 1)
        this.filesError = null
      },
      cutText (value, tooltip) {
        if (value != null && value.length > 8) {
          if (tooltip) {
            const tail = value.split('.')[1]
            if (!this.$vuetify.breakpoint.smAndDown) {
              return value.slice(0, 70) + '....' + tail
            }
            return value.slice(0, 20) + '....' + tail
          }
          return value.slice(0, 5) + ' ...'
        }
        return value
      }
    },
  }
</script>

<style lang="sass" scoped>
  @import "scss/variables.scss"
  @import "scss/colors.scss"



  @media(max-width: $xsOnly)
    .card-actions-style
      margin-top: 6px
    .card-rc
      padding: 20px

    .text-footer
      font-size: 14px
      line-height: 16px

    .text-footer-md
      margin-bottom: 20px !important

    .error-style
      font-size: min(calc(5px + 1.5vw), 11px)

  @media(min-width: $xsOnlyStart) and (max-width: 610px)
    .card-actions-style
      margin-top: 13px

  @media(min-width: 700px)
    .chip-space
      display: flex
      justify-content: space-between

  @media(min-width: $smAndUp)
    .card-rc
      padding: 40px
      width: 100%
      margin-top: 3%

    .text-footer
      font-size: 16px
      line-height: 19px

    .error-style
      font-size: 13px

  .files-row-style
    min-height: 40px

  .link-document
    text-decoration: none

  .error-row-style
    margin: 0
    height: 20px

  .error-style
    height: 15px
    margin-left: 20px
    margin-bottom: 0
    font-family: RobotoRegular

  .card-rc
    background: $regisrationCardBackground
    max-width: 600px
    border-radius: 20px !important

  .imput-rc
    align-items: flex-end
    justify-content: flex-start
    display: flex

  .hide-scrollbar
    -ms-overflow-style: none
    scrollbar-width: none
    ::-webkit-scrollbar
      display: none

  .input-icon
    max-width: 18px
    max-height: 19px
    margin-right: 5px
    flex: initial
    color: $blueBasic
    margin-bottom: 8px

  .text-input-rc
    color: $blueBasic
    margin-bottom: 3px
    font-size: 16px
    font-family: RobotoRegular

  .text-footer
    color: $greyText
    font-family: RobotoRegular
    margin-bottom: 0
    text-align: center

  .text-footer-md
    margin-bottom: 30px

  .text-style
    color: $greyText
    font-size: 16px
    font-family: RobotoRegular
  .text-mb-0
    margin-bottom: 0
  .text-mb-4
    margin-bottom: 4px
  .text-mb-5
    margin-bottom: 5px

  .text-dialog
    font-family: RobotoRegular

  .row-style
    margin: 0

  .height-details
    margin-top: 1%
    margin-bottom: 10px
    height: 20px

  .white-text
    color: $white
    background: $blueBasic
    outline: 1px solid $blueBasic

  .v-chip::before
    opacity: 0 !important

  .base-style
    color: $blueBasic
    background: transparent !important
    outline: 1px solid $blueBasic

  .card-actions-style
    padding: 0 8px

  .btn-style
    elevation: 0
    color: $white
    font: $btnFont
    background: $btnColor
    letter-spacing: 0.01em
    width: 191px
    margin-bottom: 16px
    margin-top: 6px

  .btn-color
    background: $btnColor

  .text-fild-rc
    ::v-deep
      .v-input__control
        max-width: 600px
        border-radius: 10px
        margin-bottom: 5px
        background: $white
        opacity: 8
        .v-input__slot
          min-height: 50px !important
          display: flex !important
          align-items: center !important

  .textarea-rc
    ::v-deep
      .v-input__control
        max-width: 600px
        border-radius: 10px
        margin-bottom: 5px
        background: $white
        opacity: 8
        .v-input__slot
          height: 100px !important
          display: flex !important
          align-items: center !important
          padding: 0 12px 3px 12px !important

  .lend-chip
    justify-content: left
    width: 100%
    ::v-deep
      .v-chip--label
        border-radius: 1px !important
      .v-slide-group__wrapper
        .v-slide-group__content
          padding: 0
    .size-chip
      height: 39px !important
      min-width: 51px
      justify-content: center
      text-align: center !important
      margin-top: 8px
      margin-bottom: 8px
      margin-left: 1px
      background-color: $blueBasic
    .size-chip-employe
      width: 100%
      max-width: 51px

  .max-textarea
    max-height: 120px
    overflow-y: auto
</style>